

export class GrossMassContainerModel {
    containerId: number;
    containerNumber: string;
    containerSize: string;
    saleOrderId: number;
    employeeId: number;
    authorisedBy: string;
    employeeName: string;
    designation:string;
    exporterId: number;

    constructor (containerId: number, containerNumber: string, containerSize: string, saleOrderId:number,employeeId:number,authorisedBy:string,employeeName:string,
    designation:string,
    exporterId: number,
) {
       this.containerId=containerId;
       this.containerNumber=containerNumber;
       this.containerSize=containerSize;
       this.saleOrderId=saleOrderId;
       this.employeeId=employeeId;
       this.authorisedBy=authorisedBy;
       this.employeeName=employeeName;
       this.designation= designation;
       this.exporterId= exporterId;
    }
}